import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Table as AntTable} from 'antd'
import {sorterNum} from 'Utils'
import {stockFilterTags} from 'Components/Screener/stockFilterTags.js'

@inject('store') @observer
class Table extends Component {
  getColumns() {
    const {tickers} = this.props.store.stockFilter.single.data.selected_tickers
    let columns = [{
      title: 'Ticker',
      dataIndex: 'ticker',
      sorter: (a, b) => {
        const aSymbol = typeof a.ticker === 'object' ? a.ticker.symbol : a.ticker
        const bSymbol = typeof b.ticker === 'object' ? b.ticker.symbol : b.ticker
        return aSymbol.localeCompare(bSymbol)
      },
      render: (text, record) => {
        if (typeof record.ticker === 'object') {
          return record.ticker.symbol
        }
        return text
      }
    }]
    if (tickers.length) {
      if (typeof tickers[0].ticker === 'object') {
        columns.push({
          title: 'Name',
          dataIndex: 'ticker.symbol_name',
          sorter: (a, b) => a.ticker?.symbol_name?.localeCompare(b.ticker?.symbol_name)
        })
      }
      for (let col in tickers[0].data) {
        if (col !== '0' && col !== 'key') {
          const tagObj = stockFilterTags.filter(obj => obj.tag == col)[0]
          const title = tagObj.name || tagObj.tag
          columns.push({
            title: title,
            dataIndex: `data.${col}`,
            sorter: (a, b) => sorterNum(a.data[col], b.data[col]),
            render: (text) => `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          })
        }
      }
    }
    return columns
  }
  onChange = (selectedRowKeys) => {
    this.props.store.stockFilter.single.selectRow(selectedRowKeys)
  }
  rowKey = (record) => {
    if (typeof record.ticker === 'object') {
      return record.ticker.symbol
    } else {
      return record.ticker
    }
  }
  render() {
    const {single, loadingTickers} = this.props.store.stockFilter
    const {foundTickers, selectedRowKeys} = single
    return(
      <AntTable
        rowSelection={{
          selectedRowKeys: selectedRowKeys,
          onChange: this.onChange
        }}
        dataSource={foundTickers}
        columns={this.getColumns()}
        rowKey={this.rowKey}
        size='small'
        pagination={{pageSize: 17, showTotal: total => `Total ${total} items`}}
        loading={loadingTickers}
        locale={loadingTickers ? {
          emptyText: 'Loading'
        } : {
          emptyText: 'No Data'
        }}
      />
    )
  }
}

export default Table
